export default {
  'delegatedTasks.title': 'Manage Delegated Tasks',

  'delegatedTasks.form.status': 'Status',
  'delegatedTasks.form.process': 'Process',
  'delegatedTasks.form.environment': 'Environment',
  'delegatedTasks.form.processInstanceName': 'Request Name',
  'delegatedTasks.form.name': 'Delegated User',
  'delegatedTasks.form.actionInstanceId': 'Execution Step',
  'delegatedTasks.form.created': 'Creation Date',

  'delegatedTasks.delegated': 'Delegated',
  'delegatedTasks.deleted': 'Removed',
};
